import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { RequireStaff } from "@/components/Guard";
import { LoginPage } from "@/pages/Login";
import { OverviewPage } from "@/pages/Overview";
import { UsersPage } from "@/pages/Users";
import { UserDetailPage } from "@/pages/UserDetail";
import { LibraryPage } from "@/pages/Library";
import { PushPage } from "@/pages/Push";
import { FlagsPage } from "@/pages/Flags";
import { ConfigPage } from "@/pages/Config";
import { ErrorsPage } from "@/pages/Errors";
import { SecurityPage } from "@/pages/Security";
import { AuditPage } from "@/pages/Audit";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<RequireStaff />}>
        <Route element={<Layout />}>
          <Route index element={<OverviewPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          <Route path="library" element={<LibraryPage />} />
          <Route path="push" element={<PushPage />} />
          <Route path="flags" element={<FlagsPage />} />
          <Route path="config" element={<ConfigPage />} />
          <Route path="errors" element={<ErrorsPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="audit" element={<AuditPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
